import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

export const AqlAppEndPoints = {
  GET_SIZE_QUANTITY_LIST: 'GET_SIZE_QUANTITY_LIST',
  GET_MEASUREMENTS_LIST_BASED_ON_SIZE: 'GET_MEASUREMENTS_LIST_BASED_ON_SIZE',
  GET_AQL_LEVELS_BY_BUYER_DEPARTMENT: 'GET_AQL_LEVELS_BY_BUYER_DEPARTMENT',
  GET_AQL_LISTING_PAGES_LOGS: 'GET_AQL_LISTING_PAGES_LOGS',
  GET_AQL_AUDIT_SUMMARY: 'GET_AQL_AUDIT_SUMMARY',
};

type TAqlAppEndPoints = typeof AqlAppEndPoints;
type TAqlAppEndPointsTypes = keyof TAqlAppEndPoints;

@Injectable({ providedIn: 'root' })
export class AqlAppEnvService {
  public mode = 'dev';

  HOST_DOMAIN;
  HOST_DOMAIN_WITH_PROTOCOL;
  LOG_HBASE_HOST_DOMAIN;
  LOG_HBASE_HOST_DOMAIN_WITH_PROTOCOL;

  private env_vars: TAqlAppEndPoints = {
    GET_SIZE_QUANTITY_LIST: '',
    GET_MEASUREMENTS_LIST_BASED_ON_SIZE: '',
    GET_AQL_LEVELS_BY_BUYER_DEPARTMENT: '',
    GET_AQL_LISTING_PAGES_LOGS: '',
    GET_AQL_AUDIT_SUMMARY: '',
  };

  constructor(@Inject('environment') environment: TInputAppEnvironmentVars) {
    if (environment.mode) {
      this.mode = environment.mode;
    }

    this.HOST_DOMAIN = environment.service_host;
    this.HOST_DOMAIN_WITH_PROTOCOL = environment.protocol + this.HOST_DOMAIN;

    this.LOG_HBASE_HOST_DOMAIN = environment.log_hbase_host;
    this.LOG_HBASE_HOST_DOMAIN_WITH_PROTOCOL = environment.protocol + this.LOG_HBASE_HOST_DOMAIN;

    this.registerVars(environment);
  }

  private registerVars(environment: TInputAppEnvironmentVars) {
    this.env_vars.GET_SIZE_QUANTITY_LIST =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.bulk_count_app_services + '/api/v1/washing/sent/quantity';
    this.env_vars.GET_MEASUREMENTS_LIST_BASED_ON_SIZE =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/api/v2/getpoms/listing/byFactoryId';
    this.env_vars.GET_AQL_LISTING_PAGES_LOGS = this.LOG_HBASE_HOST_DOMAIN_WITH_PROTOCOL + '/api/hbase/search';
    this.env_vars.GET_AQL_AUDIT_SUMMARY = this.HOST_DOMAIN_WITH_PROTOCOL + '/data_gateway/ext/v2/search';
    this.env_vars.GET_AQL_LEVELS_BY_BUYER_DEPARTMENT =
      this.HOST_DOMAIN_WITH_PROTOCOL + environment.core_services + '/api/v2/getaqllevels/byFactoryIdBuyerAndDepartment';
  }

  public getEnvVar(arg: TAqlAppEndPointsTypes): string {
    return this.env_vars[arg];
  }
}
